import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let DatepickerComp;

class DatePicker extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: DatepickerComp };
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/datepicker-comp" */
            "../../../components/javascript/zcat-components/datepicker-comp"
        ).then(function(res) {
            DatepickerComp = res.DatepickerComp;
        }));

        
;
    }
}

export {DatePicker};

